import React, { useState } from "react";

import { useShirtArea } from "../../hooks";

import { EmbroideryImg, PrintImg } from "../../images";

import { CommonShirtImage, ErrorWrapper } from "../decorate";

function TermsAndConditions({
  termsAccepted,
  isEmbroidery,
  handleCustomizationDetails,
}) {
  const { fees, printType, terms } = useShirtArea();
  const [isPrint, setIsPrint] = useState(null);

  return (
    <div>
      <div className="row">
        <div className="col-lg-7">
          <div className="terms-conditions">
            {/* <div
              className="terms-conditions-content"
              dangerouslySetInnerHTML={{ __html: terms }}
            ></div> */}

            <CommonShirtImage style={{ border: "none" }} />

            <div className="form-check" style={{ paddingLeft: 0 }}>
              <ErrorWrapper
                name={"terms"}
                Component={({ style = {} }) => (
                  <div style={{ ...style }}>
                    <div>
                      <input
                        id="flexCheckDefault"
                        className="form-check-input"
                        type="checkbox"
                        name="termsAccepted"
                        checked={termsAccepted}
                        onChange={(e) => handleCustomizationDetails(e.target)}
                      />
                    </div>
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                      style={{
                        fontSize: 16,
                        marginLeft: 20,
                        color: "#6C7275",
                        cursor: "pointer",
                        ...(style?.color && { color: style?.color }),
                      }}
                    >
                      I agree to the terms and conditions.
                    </label>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="select-by-one-area">
            <h2
              style={{
                margin: "20px 0px 0px",
                textAlign: "center",
                marginBottom: 40,
              }}
              className="logo-type-heading"
            >
              Select Logo Type
            </h2>

            <div className="select-logo-type">
              <button
                onClick={() => {
                  handleCustomizationDetails({
                    name: "isEmbroidery",
                    value: false,
                  });
                  setIsPrint(true);
                }}
                className={`custom-select-btn ${
                  isPrint !== null && isPrint ? "activeLogoType" : ""
                } ${!printType?.isPrint ? "custom-disable" : ""}`}
                disabled={!printType?.isPrint}
                style={{
                  ...(isPrint !== null && isPrint
                    ? { backgroundColor: "#eeeeee" }
                    : {}),
                }}
              >
                <img src={PrintImg} alt="" />
                <h6 className="mb-0 text-muted">Print</h6>
              </button>

              <button
                onClick={() => {
                  handleCustomizationDetails({
                    name: "isEmbroidery",
                    value: true,
                  });
                  setIsPrint(false);
                }}
                className={`custom-select-btn ${
                  isPrint !== null && !isPrint ? "activeLogoType" : ""
                } ${!printType?.isEmbroidery ? "custom-disable" : ""}`}
                disabled={!printType?.isEmbroidery}
                style={{
                  ...(isPrint !== null && !isPrint
                    ? { backgroundColor: "#eeeeee" }
                    : {}),
                }}
              >
                <img src={EmbroideryImg} alt="" />
                <h6 className="mb-0 text-muted">Embroidery</h6>
              </button>
            </div>
            <ErrorWrapper name="type" style={{ marginTop: 3 }} />
            <div className="cost-area">
              <h5>Personalisation Cost</h5>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Per Logo Print </span>
                <span className="price">£{fees?.logo_print_fee || "0"}.00</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Per Logo Embroidery </span>
                <span className="price">£{fees?.embroidery_fee || "0"}.00</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">One-Time Setup Fee (Free) </span>
                <span className="price">£0.00</span>
              </div>
              <div className="border"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
